import React, { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (localStorage.getItem("admin_token")) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("admin_token", data.token);
      localStorage.setItem("admin_email", data.email);
      navigate("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-slate-900 border border-slate-800 rounded-md p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-6 h-6 bg-[#016C36] rounded-sm flex items-center justify-center">
            <span className="text-white font-display font-black text-xs">+</span>
          </div>
          <span className="font-display font-black tracking-tight">SAFEMAT / ADMIN</span>
        </div>
        <h1 className="font-display font-bold text-2xl mb-6">Login</h1>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div>
            <label className="text-xs text-slate-400 block mb-2">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-slate-950 border border-slate-700 rounded px-3 py-2.5 text-sm focus:border-[#016C36] focus:outline-none"
              data-testid="login-email" />
          </div>
          <div>
            <label className="text-xs text-slate-400 block mb-2">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-slate-950 border border-slate-700 rounded px-3 py-2.5 text-sm focus:border-[#016C36] focus:outline-none"
              data-testid="login-password" />
          </div>
          {error && <p className="text-[#016C36] text-sm">{error}</p>}
          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="login-submit">
            {loading ? <Loader2 size={16} className="animate-spin" /> : null} Sign in
          </button>
        </form>
      </div>
    </div>
  );
}
